import React, { useCallback, useEffect, useMemo } from "react"
import { useApi, WithApi } from "./api"
import _ from "lodash"
import { WithStore } from "./store"
import { useDispatch, useSelector } from "react-redux"
import { requestInitAction, useInit } from "@store/init"
import { useAllFeatures } from "@store/appReducers"
import LoadConfigs from "@context/LoadConfigs"
import { CompleteAccountContext } from "@context/CompleteAccountContext"
import Kiosk from "@ui/Kiosk"
import FooterWithAppLinks from "@ui/FooterWithAppLinks"
import { HashRouter } from "react-router-dom"
import AppRoutes from "./AppRoutes"
import { requestDailyPackStatusAction } from "@store/packs/actions"
import { CenteredInKioskView } from "@ui/ViewContainer"
import { WithAppLinks } from "@context/AppLinksContext"
import { IAppState } from "@store/appState"
import OnlyEnterCode, { KioskWrapperWhenOnlyEnterCode, WrapperWhileLoadingConfigsOnlyEnterCode } from "@view/OnlyEnterCode"
import OptinsContext, { useFetchOptinsInfo } from "@context/OptinsContext"
import LoadingSpinner from "@ui/LoadingSpinner"
import Optins from "@view/Optins"
import { useScreenTracking } from "@api/tracking"

export interface AppProps {
  ios_url: string
  android_url: string
  api_host: string
  locale: string
  asset_host: string
  connect_error?: string
  onlyEnterCode?: boolean
}

const CompleteApp: React.FC = () => {
  useScreenTracking("/teaser_experience")
  return <HashRouter>
    <AppRoutes />
  </HashRouter>
}

const AppHolderThatMountsAllFeatures: React.FC = ({children}) => {
  const dispatch = useDispatch()

  const initDone = useSelector<IAppState, boolean>((s) => s.initDone)

  useAllFeatures()

  useEffect(() => { // send initial requests to server
    dispatch(requestInitAction())
    dispatch(requestDailyPackStatusAction())
  }, [])

  return <div className="neo__app">
    {initDone && children}
  </div>
}

const WrapperWhileLoadingConfigs: React.FC = ({ children }) => {
  return <Kiosk whileLoading><CenteredInKioskView>{children}</CenteredInKioskView></Kiosk>
}

const startConnectAccount = () => {
  console.warn("trigger registration here")
  // (window as any).APP.require("gigya").triggerRegistration()
}

const App: React.FC<AppProps> = (props) => {
  return <WithApi apiHost={props.api_host}>
    <AppInner {...props} />
  </WithApi>
}

const AppInner: React.FC<AppProps> = ({ios_url, android_url, asset_host, locale, connect_error, onlyEnterCode}) => {
  const { initialzed: optinsInfoInitialized, contextValue: optinsContextValue } = useFetchOptinsInfo();

  const LoadingPlaceholder = useMemo(() => onlyEnterCode ? WrapperWhileLoadingConfigsOnlyEnterCode : WrapperWhileLoadingConfigs, [ onlyEnterCode ])

  return <div className="neo__teaserExperience">
      <LoadConfigs assetHost={asset_host} locale={locale} WrapperWhileLoading={LoadingPlaceholder}>
        <CompleteAccountContext.Provider value={{completeAccount: startConnectAccount}}>
          <WithAppLinks ios={ios_url} android={android_url}>
            <WithStore connectError={connect_error}>
              {onlyEnterCode
                ? <>
                    <KioskWrapperWhenOnlyEnterCode>
                      <AppHolderThatMountsAllFeatures>
                        <OnlyEnterCode />
                      </AppHolderThatMountsAllFeatures>
                    </KioskWrapperWhenOnlyEnterCode>
                  </>
                : (optinsInfoInitialized && optinsContextValue
                    ? <OptinsContext.Provider value={optinsContextValue}>
                        <Kiosk>
                          {optinsContextValue.needsToShowOptinsScreen
                            ? <Optins />
                            : <AppHolderThatMountsAllFeatures>
                                <CompleteApp />
                              </AppHolderThatMountsAllFeatures>}
                        </Kiosk>
                      </OptinsContext.Provider>
                    : <LoadingPlaceholder><LoadingSpinner type="onDark" /></LoadingPlaceholder>)}
              <FooterWithAppLinks />
            </WithStore>
          </WithAppLinks>
        </CompleteAccountContext.Provider>
      </LoadConfigs>
  </div>
}

export default App
